import {TextField} from "@material-ui/core";
import Autocomplete from "@mui/material/Autocomplete";
import React, {FC, useEffect, useState} from "react";
import styled from "styled-components/macro";
import {FormikErrors} from "formik";

const Wrapper = styled.div`
  .MuiChip-root {
    background: #acacac;
    font-weight: 500;
  }
  .MuiAutocomplete-popupIndicator {
    color: #acacac;
  }
  .MuiAutocomplete-clearIndicator {
    color: #acacac;
  }
`

type PropsType = {
  label: string;
  options: any[]
  onSetField: (field: string, values: string[]) => void
  field: string
  error?: boolean
  helperText?: any
  value: any
}

const MultipleAutocomplete: FC<PropsType> = ({
  value,
  label,
  options,
  onSetField,
  field,
  error = false,
  helperText
}) => {
  const getValues = (values: any[], options: any[]) => {
    if (options.length > 0 && values.length > 0) {
      return values.map((i) => {
        const findOption = options.find((o) => o.value === i)
        return findOption ? findOption : {display_name: `${i} (unsupported)`, value: 'null'}
      })
    }
    return []
  }


  return (
    <Wrapper>
      <Autocomplete
        disabled={options.length === 0}
        multiple
        id={field}
        options={options}
        value={getValues(value, options)}
        getOptionLabel={(option) => option.display_name}
        isOptionEqualToValue={(option, value: any) => option.value === value.value}
        onChange={(e, value) => {
          if (value) {
            onSetField(field, value ? value.map((i) => i.value) : []);
          }
        }}
        onInputChange={(e, newInputValue, reason) => {
          if (reason === "clear") {
            onSetField(field, []);
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="outlined"
            fullWidth
            error={error}
            helperText={error && helperText}
          />
        )}
        fullWidth
      />
    </Wrapper>
  )
}

export default MultipleAutocomplete